import { inspectionStatusPath } from 'routes';

export const fetchTechnicians = async (filters) => {
  const params = new URLSearchParams();
  params.set('team_id', filters?.values?.technicianTeam || '');

  // Only send local territory filter when that filter is active. When the
  // Global Scope Selector has narrowed territories, the server scopes via
  // in_global_territories and the UI hides this filter.
  const territoryIds = filters?.values?.territory;
  if (filters?.active?.territory && Array.isArray(territoryIds) && territoryIds.length > 0) {
    territoryIds.forEach((id) => params.append('territory_ids[]', id));
  }

  const response = await fetch(`/map/technicians?${params.toString()}`);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const fetchTechnicianLocations = async (filterValues) => {
  const queryParams = new URLSearchParams();

  if (filterValues && filterValues.technicians) {
    filterValues.technicians.forEach((technicianId) => {
      queryParams.append('technicians[]', technicianId);
    });
  }

  const response = await fetch(`/map/fleet_tracking?${queryParams.toString()}`);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const updateFleetTrackingPassengers = async (techId, vehicleId) => {
  const params = { technician_id: techId, vehicle_id: vehicleId };

  const response = await fetch('/map/update_fleet_tracking_passengers', {
    method: 'post',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const deleteFleetTrackingPassengers = async (techId) => {
  const params = { technician_id: techId };

  const response = await fetch('/map/delete_fleet_tracking_passengers', {
    method: 'post',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const fetchVisitStatus = async (status) => {
  const response = await fetch(inspectionStatusPath(status));

  if (!response.ok) {
    throw new Error('Fetching visit status failed.');
  }

  return response.json();
};
